// App.js
import "./App.css"
import React, { useRef, useState } from 'react'

import  hotels from './hotels.json'
import Filter from "./components/filter/Filter";
interface Estate {
      id: number;
      title: string;
      countOfGuests: string;
      priceFrom: string;
      region:number;
      image:string;
      address:string;
    }
type FilterKeys = "location" | "priceRange" | "hotelType" | "category";
function App() {
      const elementRef = useRef<HTMLDivElement>(null);

      const [filters, setFilters] = useState<Record<FilterKeys, string>>({
            location: '',
            priceRange: '',
            hotelType: '',
            category: '',
          });
      const filteredHotels =hotels.filter((hotel) => {
            return (
              (!filters || filters.location === "მდებარეობა" || filters.location === "ყველა" || !filters.location || hotel.address.includes(filters.location)) &&
              (!filters || filters.priceRange === "ფასის დიაპაზონი" || filters.priceRange === "ნებისმიერი"  || !filters.priceRange || hotel.priceFrom === filters.priceRange) &&
              (!filters || filters.hotelType === "სასტუმროს ტიპი" || filters.hotelType === "ყველა" || !filters.hotelType || `${hotel.type}` === filters.hotelType)
            );
          });
      const handleFilterChange = (newFilters: Record<FilterKeys, string>) => {
            setFilters(newFilters);
            if (elementRef.current) {
                  elementRef.current.scrollIntoView({
                    behavior: 'smooth', // Enables smooth scrolling
                    block: 'start', // Aligns the element to the top of the viewport
                  });
                }
      };

          
      const getRandomGradient = () => {
            const blueShades = [
                  '#a8c9e6', // Light blue
                  '#7fb9d9', // Soft blue
                  '#bdd9eb', // Pale blue
                  '#b1cbe2', // Pastel blue
                  '#87b6d3', // Sky blue
                  '#cfe2f3', // Light powder blue
                ];
                const color1 = blueShades[Math.floor(Math.random() * blueShades.length)];
                const color2 = blueShades[Math.floor(Math.random() * blueShades.length)];
                return `linear-gradient(45deg, ${color1}, ${color2})`;
          };
          
    return (
<>
<header>
      <nav>
      <span className='logo nothing-you-could-do-regular'>Hotelier</span>
      <div>
            <a>სასტუმროები</a>
            <a>შეთავაზებები</a>
            <a  id="cta-header" className="cta-link">სასტუმროს დამატება</a>
      </div>
      </nav>
</header>

<main>

<section className="hero">
      <div className="hero-inner">
      <h1 className="nothing-you-could-do-regular">Hotelier</h1>
      <p>საოჯახო სასტუმროები და კოტეჯები საქართველოში</p>
      <div style={{marginTop:30}}>
            <a id="preview-apps" href="">დათვალიერება</a>
            <a href="" id="cta-link-hero" className="cta-link">დამატება</a>
      </div>
      </div>
</section>

<section className="quick-links">
      <h3 className="quick-search">სწრაფი ძებნა</h3>
      <div className="quick-links-inner">
      <div className="quick-link" style={{background:getRandomGradient()}}>
            <p>კოტეჯები <span>თბილისის შემოგარენში</span></p>
            <i className="fa-solid fa-chevron-right"></i>
      </div>
      <div className="quick-link" style={{background:getRandomGradient()}}>
            <p>საოჯახო სასტუმროები <span>მცხეთაში</span></p>
            <i className="fa-solid fa-chevron-right"></i>
      </div>
      <div className="quick-link" style={{background:getRandomGradient()}}>
            <p>სასტუმროები <span>კახეთში</span></p>
            <i className="fa-solid fa-chevron-right"></i>
      </div>
      <div className="quick-link" style={{background:getRandomGradient()}}>
            <p>კოტეჯები <span>თბილისის შემოგარენში</span></p>
            <i className="fa-solid fa-chevron-right"></i>
      </div>
      </div>
</section>


<div  ref={elementRef}></div>
<Filter onFilterChange={handleFilterChange}></Filter>
<h1  className="listing-title">ნაპოვნია {filteredHotels.length} განცხადება</h1>   
<section className="listing" >   
{filteredHotels.map((hotel: Estate) => (
          <div key={hotel.id} className="card">
            <img
              src={hotel.image.replace("/s/", "/").replace(/-\w+(?=\.\w+)/, "")} // Placeholder image URL
              alt={hotel.title}
              className="card-image"
            />
            <div className="card-content">
              <h2 className="card-title">{hotel.title}</h2>
              <p className="card-location">{hotel.address}</p>
              <p className="card-guests">სტუმრების რაოდენობა: {hotel.countOfGuests}</p>
              <p className="card-guests">{hotel.priceFrom}</p>
              {/* <button className="card-button">დათვალიერება</button> */}
            </div>
          </div>
        ))}

</section>
</main>
      </>

)}

export default App;
